import axios from "../config/axios";
import { useQuery } from "react-query";

// [4]
const getTocsByBookId = async(book_id:string) => {
 const res = await axios.GENERAL.get("/tocs/by_book_id/"+book_id)
 if(res.status === 200) {
   console.log("getTocsByBookId", res)
   return res.data
 }
}
// [4-1]
const getTocById = async (toc_id: string) => {
  const res = await axios.GENERAL.get("/tocs/by_toc_id/"+toc_id)
  if (res.status === 200) {
    console.log("getTocById", res)
    return res.data
  }
}
// [5]
// INPUT
// words_in_toc:['text', 'text', ...]
const getTocSearch = async(textlist:string[]) => {
  const res = await axios.GENERAL.post(
    "tocs/search_by_toc_title", {"words_in_toc": textlist});
  if (res.status === 200) {
    console.log("getTocSearch", res);
    return res.data;
  }
}

// relation
// [13]
// INPUT(AND) 3개 중 하나는 반드시 있어야 함
// school_id \ if null select All
// person_id\ if null select All
// region_id\ if null select All
const getTocsBySPR = async(query:any) => {
  const res = await axios.GENERAL.post("/tocs/relation", query);
  if (res.status === 200) {
    console.log("getTocsBySPR", res);
    return res.data;
  }
}
// [13-1]
const getTocsBySchoolId = async(school_id:string) => {
  const res = await axios.GENERAL.get("/tocs/related_by_school/"+school_id)
  if (res.status === 200) {
    console.log("getTocsBySchoolId", res);
    return res.data
  }
}
// [13-2]
const getTocsByPersonId = async(person_id:string) => {
  const res = await axios.GENERAL.get("/tocs/related_by_person/"+person_id)
  if (res.status === 200) {
    console.log("getTocsByPersonId", res);
    return res.data
  }
}
// [13-3]
const getTocsByRegionId = async(region_id:string) => {
  const res = await axios.GENERAL.get("/tocs/related_by_region/"+region_id)
  if (res.status === 200) {
    console.log("getTocsByRegionId", res);
    return res.data
  }
}

export default {
  getTocsByBookId,
  getTocSearch,
  getTocById,
  getTocsBySPR,
  getTocsBySchoolId,
  getTocsByPersonId,
  getTocsByRegionId
}